import React from 'react'


export const Preloader = () => {
  return (
    <div id="ploader">
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    </div>
  )
}
